import React, { useState, useEffect, version } from "react";
import { useNavigate } from "react-router-dom";
import {
  cash,
  cash_in,
  cash_out,
  open_cash,
  orders,
  total_sale_icon,
  PlusIcon,
  MinusIcon,
  info_icon,
  DashboardMoon,
  DashboardLamp,
  version_logo,
} from "../../assets";
// import Dashboard_Table from "../components/Tables/Dashboard_Table";
import { DatePicker } from "antd";
import { openSessionInfo } from "../../Redux/Action/loginAction";
import { useDispatch } from "react-redux";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { useSelector } from "react-redux";
import CashIn_Modal from "../Modal/CashIn_Modal";
import CashOut_Modal from "../Modal/CashOut_Modal";
import { useTranslation } from "react-i18next";
import { detectWebDeviceType, isTablet } from "../../utils";
import PaymentTiles from "./Dashboard Componets/paymentTiles";
import CollectionTiles from "./Dashboard Componets/paymentTiles";
// import { SalesDashboard } from "../Api";

// const dateFormat = 'DD/MM/YYYY';

function Dashboard() {
  const { t, i18n } = useTranslation();
  // sessionStorage.setItem("user","1")
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector((state) => state?.login?.user?.result);
  const [dashboardData, setDashboardData] = useState({});
  const [cashInModal, openCashInModal] = useState(false);
  const [cashOutModal, openCashOutModal] = useState(false);
  const appVersion = process.env.REACT_APP_VERSION;
  const deviceType = detectWebDeviceType();
 const showTotalCredit = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_show_total_credit
  );
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      // setLoading(true)
      const response = await axiosInstance.post(URLS.OPEN_SESSION_INFO, {
        user_id: userData?.user_id,
        company_id: userData?.company_id,
      });
      // console.log("response==>", response?.data?.result?.session_status)
      if (response?.data?.result?.status === 200) {
        setDashboardData(response?.data?.result?.response[0]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      // setLoading(false)
    }
  };

  const handleKeyDown = (e) => {
    // Normalize Arabic keyboard input to corresponding English keys
    const key = e.key.toLowerCase();
    const normalizedKey =
      {
        ـ: "j", // Arabic "ض" is similar to English "J"
        "،": "k", // Arabic "ك" is similar to English "K"
        س: "s", // Arabic "س" is similar to English "S"
        ى: "n", // Arabic "ن" is similar to English "N"
      }[key] || key;

    if (e.shiftKey && (normalizedKey === "j" || normalizedKey === "ـ")) {
      e.preventDefault();
      openCashInModal(true);
      openCashOutModal(false);
    } else if (e.shiftKey && (normalizedKey === "k" || normalizedKey === "،")) {
      e.preventDefault();
      e.stopPropagation();
      openCashOutModal(true);
      openCashInModal(false);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const CreditClick = () => {
    navigate("/credit");
  };

  return (
    <>
      {cashInModal && (
        <CashIn_Modal
          title="Cash In"
          onClose={() => openCashInModal(false)}
          handleSubmit={() => {
            getData();
            openCashInModal(false);
          }}
        />
      )}
      {cashOutModal && (
        <CashIn_Modal
          title="Cash Out"
          onClose={() => openCashOutModal(false)}
          handleSubmit={() => {
            getData();
            openCashOutModal(false);
          }}
          cashDifference={dashboardData?.cash_difference}
        />
      )}

      <div
        className={`px-10 mb-6 flex bg-[#EEEEEE] flex-wrap w-full ${
          deviceType == "tablet" ? "" : "gap-5"
        }`}
      >
        <div className={`flex flex-wrap w-full ${
          deviceType == "tablet" ? "my-4" : ""
        }`}>
          <h1 className="text-3xl font-semibold mt-7 mb-2 text-slate-900">
            {i18n.language == "ar"
              ? userData?.company_name_ar
              : userData?.company_name}
          </h1>
          <div className="flex flex-row items-center bg-[#CEFCEC] rounded-full pe-8 ps-2 mx-8">
            <img src={DashboardMoon} alt="" className="w-20 h-20 pt-2" />
            <p className="text-xl font-semibold text-[#137D6B]">
              {t("Ramadan Kareem, Wishing You Good Sales Today")}
            </p>
          </div>
        </div>

        <div
          className={`flex flex-col  items-start  pr-6 pl-6 bg-[#FFFFFF] rounded-[18px] w-[370px] text-zinc-800 relative ${
            deviceType == "tablet" ? "me-2.5  py-2 " : "py-4 "
          }`}
        >
          <div className="flex flex-row justify-between w-full ">
            <div
              className={`absolute -top-1 ${i18n.language == "ar" ? "left-0" : "right-0"} `}
            >
              <img src={DashboardLamp} alt="" className="w-20 h-20 pt-1" />
            </div>

            <div className="flex flex-row  me-2">
              <img
                src={total_sale_icon}
                alt=""
                className="aspect-square w-[45px]"
              />
              <h2
                className={`mt-3 mx-4 ${
                  deviceType == "tablet" ? "text-lg" : "text-xl"
                }`}
              >
                {t("Total Sales")}
              </h2>
              {/* <button className="focus:outline-none">
                <span className="text-blue-500">i</span>
              </button> */}
              <button
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  outline: "none",
                  marginTop: "0.5rem", // equivalent to mt-2
                }}
              >
                <img
                  src={info_icon}
                  alt="info"
                  className="w-4 h-5 object-contain"
                />{" "}
                {/* Replace with your icon */}
              </button>
              <div
                // className="absolute left-full w-60 bg-white text-gray-700 text-sm rounded-md shadow-lg p-2 hidden tooltip"
                className={`absolute ${
                  i18n.language === "ar" ? "right-full" : "left-full"
                } w-60 bg-white text-gray-700 text-sm rounded-md shadow-lg p-2 hidden tooltip`}
              >
                <p>{t("Total Sales = Cash Collection + Bank Collection")}</p>
                <br></br>
                {/* <p>
                  {t("Total Earnings = Total Sales - Total Refunded Amount")}
                </p> */}
              </div>
            </div>
          </div>
          <p
            className={`${
              deviceType == "tablet" ? "text-[1.275rem] py-2" : "text-3xl py-6"
            }  font-semibold`}
          >
            {i18n.language === "ar" ? (
              <>
                EGP {dashboardData?.total_earning?.toFixed(2) || 0}
                {/* / EGP{" "}
                {dashboardData?.total_sales?.toFixed(2) || 0} */}
              </>
            ) : (
              <>
                {/* EGP {dashboardData?.total_sales?.toFixed(2) || 0} /  */}
                EGP {dashboardData?.total_earning?.toFixed(2) || 0}
              </>
            )}
          </p>
        </div>

        {/* Opening Cash Card */}
        <div
          className={`flex flex-col  items-start py-4 pr-6 pl-6 bg-[#FFFFFF] rounded-[18px] w-[370px] text-zinc-800 relative ${
            deviceType == "tablet" ? "me-2.5  " : ""
          }`}
        >
          <div className="flex flex-row">
            <div
              className={`absolute -top-1 ${i18n.language == "ar" ? "left-0" : "right-0"} `}
            >
              <img src={DashboardLamp} alt="" className="w-20 h-20 pt-1" />
            </div>
            <img src={open_cash} alt="" className="aspect-square w-[45px]" />
            <h2
              className={`mt-3 mx-4 ${
                deviceType == "tablet" ? "text-lg" : "text-xl"
              }`}
            >
              {t("Opening Cash")}
            </h2>
          </div>
          <p
            className={`${
              deviceType == "tablet" ? "text-[1.275rem] py-2" : "text-3xl py-6"
            } font-semibold`}
          >
            EGP {dashboardData?.opening_cash?.toFixed(2) || 0}
          </p>
        </div>

        <div
          onClick={() => openCashInModal(true)}
          className={`cursor-pointer flex  flex-col items-start py-4 pr-6 pl-6 bg-[#FFFFFF] rounded-[18px] w-[370px] text-zinc-800 ${
            deviceType == "tablet" ? "me-2.5  " : ""
          }`}
        >
          <div className="flex flex-row justify-between w-full">
            <div className="flex flex-row">
              <img src={cash_in} alt="" className="aspect-square w-[45px]" />
              <h2
                className={`mt-3 mx-4 ${
                  deviceType == "tablet" ? "text-lg" : "text-xl"
                }`}
              >
                {t("Cash In")}
              </h2>
            </div>
            <div className=" bg-[#fff0c7] rounded-3xl mt-2 p-2 ">
              <img src={PlusIcon} alt="" className="  aspect-square w-[20px]" />
            </div>
          </div>
          <p
            className={`${
              deviceType == "tablet" ? "text-[1.275rem] py-2" : "text-3xl py-6"
            } font-semibold`}
          >
            EGP {dashboardData?.cash_in_amt?.toFixed(2) || 0}
          </p>
        </div>

        <div
          onClick={() => openCashOutModal(true)}
          className={`cursor-pointer flex  flex-col items-start py-4 pr-6 pl-6 bg-[#FFFFFF] rounded-[18px] text-zinc-800  w-[370px] ${
            deviceType == "tablet" ? "mt-2.5 me-2.5  " : ""
          }`}
        >
          <div className="flex flex-row justify-between w-full">
            <div className="flex flex-row">
              <img src={cash_out} alt="" className="aspect-square w-[45px]" />

              <h2
                className={`mt-3 mx-4 ${
                  deviceType == "tablet" ? "text-lg" : "text-xl"
                }`}
              >
                {t("Cash Out")}
              </h2>
            </div>
            <div className=" bg-[#fff0c7] rounded-3xl mt-2 p-2 flex items-center ">
              <img
                src={MinusIcon}
                alt=""
                className="  aspect-square w-[20px]"
              />
            </div>
          </div>
          <p
            className={`${
              deviceType == "tablet" ? "text-[1.275rem] py-2" : "text-3xl py-6"
            } font-semibold`}
          >
            EGP {(-dashboardData?.cash_out_amt)?.toFixed(2) || 0}
          </p>
        </div>

        {/* Number of Orders Card */}
        <div
          className={`flex flex-col  items-start py-4 pr-6 pl-6 bg-[#FFFFFF] rounded-[18px] w-[370px] h-[100%] text-zinc-800 relative  ${
            deviceType == "tablet" ? "mt-2.5 me-2.5  " : ""
          }`}
        >
          <div className="flex flex-row">
            <div
              className={`absolute -top-1 ${i18n.language == "ar" ? "left-0" : "right-0"} `}
            >
              <img src={DashboardLamp} alt="" className="w-20 h-20 pt-1" />
            </div>
            <img src={orders} alt="" className="aspect-square w-[45px]" />
            <h2
              className={`mt-3 mx-4 ${
                deviceType == "tablet" ? "text-lg" : "text-xl"
              }`}
            >
              {t("No. of Orders")}
            </h2>
          </div>
          <p
            className={`${
              deviceType == "tablet" ? "text-[1.275rem] py-2" : "text-3xl py-6"
            } font-semibold`}
          >
            {dashboardData?.total_orders || 0}
            {/* <span className="ml-2 text-zinc-500">Products</span> */}
          </p>
        </div>

        {/* Available Cash Card */}
        <div className={` ${deviceType == "tablet" ? "mt-2.5 me-2.5  " : ""}`}>
          <div className="flex flex-row items-start py-2 pr-6 pl-6 bg-[#FFF0C7] rounded-[18px] w-[1145px] h-[100%] text-zinc-800 ">
            <div className="flex flex-row items-start w-[37%]">
              <img src={cash} alt="" className="aspect-square w-[45px] mt-5" />
              <div className="flex flex-col mt-8">
                <div className="flex flex-row">
                  <h2
                    className={` mx-4 ${
                      deviceType == "tablet" ? "text-lg" : "text-xl"
                    }`}
                  >
                    {t("Available Cash")}
                  </h2>
                  <div className="relative mt-1">
                    <button
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        outline: "none",
                      }}
                    >
                      <img
                        src={info_icon}
                        alt="info"
                        className="w-4 h-5 object-contain"
                      />{" "}
                    </button>
                    <div
                      className={`absolute ${
                        i18n.language === "ar" ? "right-full" : "left-full"
                      } w-72 bg-white text-gray-700 text-sm rounded-md shadow-lg p-5 hidden tooltip`}
                    >
                      {/* // className="absolute left-full w-72 bg-white text-gray-700 text-sm rounded-md shadow-lg p-5 hidden tooltip"> */}
                      <p>
                        {t(
                          "Available Cash = Cash Collection + Opening Cash + Cash In - Total Refund Amount - Cash Out",
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                {/* <br></br> */}
                <p
                  className={`${
                    deviceType == "tablet"
                      ? "text-[1.275rem] py-2"
                      : "text-3xl py-6"
                  }  font-semibold`}
                >
                  EGP {(-dashboardData?.cash_difference || 0).toFixed(2)}
                  {/* EGP {-dashboardData?.cash_difference || 0} */}
                </p>
              </div>
            </div>
            {/* Small Cards */}
            <div className="flex items-start w-[66%]">
              {/* Cash Collection */}
              <div
                className={`flex flex-col mx-4 items-start ${
                  deviceType == "tablet" ? "h-[140px]" : ""
                } py-6 px-4 bg-[#FFFAFA] rounded-[18px] w-[354px] text-zinc-800`}
              >
                <div className="flex items-center">
                  <img src={cash} alt="" className="me-3.5" />
                  <p
                    className={`${
                      deviceType == "tablet"
                        ? "text-[1.275rem] py-2"
                        : "text-3xl py-6"
                    }  font-semibold`}
                  >
                    EGP {dashboardData?.collected_cash?.toFixed(2) || 0}
                  </p>
                </div>
                <h3
                  className={`${
                    deviceType == "tablet" ? "text-base" : "text-lg"
                  } ms-16`}
                >
                  {t("Total Cash Collection")}
                </h3>
              </div>
              {/* ))} */}

              {/* Bank Collection */}
              <div
                className={`flex flex-col mx-4 items-start ${
                  deviceType == "tablet" ? "h-[140px]" : ""
                } py-6 px-4 bg-[#FFFAFA] rounded-[18px] w-[354px] text-zinc-800`}
              >
                <div className="flex items-center">
                  <img src={total_sale_icon} alt="" className="me-3.5" />
                  <p
                    className={`${
                      deviceType == "tablet"
                        ? "text-[1.275rem] py-2"
                        : "text-3xl py-6"
                    }  font-semibold`}
                  >
                    EGP {dashboardData?.bank_collection?.toFixed(2) || 0}
                  </p>
                </div>
                <h3
                  className={`${
                    deviceType == "tablet" ? "text-base" : "text-lg"
                  } ms-16`}
                >
                  {t("Total Bank Collection")}
                </h3>
              </div>
            </div>
          </div>
        </div>

        {/* No. Refunded Orders */}
        <div
          className={`flex  flex-col items-start py-4 pr-6 pl-6 bg-[#FFFFFF] rounded-[18px] w-[370px] text-zinc-800 relative ${
            deviceType == "tablet" ? "me-2.5 mt-2.5  " : ""
          }`}
        >
          <div className="flex flex-row">
            <div
              className={`absolute -top-1 ${i18n.language == "ar" ? "left-0" : "right-0"} `}
            >
              <img src={DashboardLamp} alt="" className="w-20 h-20 pt-1" />
            </div>
            <img
              src={total_sale_icon}
              alt=""
              className="aspect-square w-[45px]"
            />
            <h2
              className={` mx-4 mt-3 ${
                deviceType == "tablet" ? "text-lg" : "text-xl"
              }`}
            >
              {t("No. of Refunded Orders")}
            </h2>
          </div>
          <p
            className={`${
              deviceType == "tablet" ? "text-[1.275rem] py-2" : "text-3xl py-6"
            }  font-semibold`}
          >
            {dashboardData?.refunded_order || 0}
          </p>
        </div>

        {/* Total Refunded Amount */}
        <div
          className={`flex flex-col items-start py-4 pr-6 pl-6 bg-[#FFFFFF] rounded-[18px] w-[370px] text-zinc-800 relative ${
            deviceType == "tablet" ? "me-2.5 mt-2.5  " : ""
          }`}
        >
          <div className="flex flex-row">
            <div
              className={`absolute -top-1 ${i18n.language == "ar" ? "left-0" : "right-0"} `}
            >
              <img src={DashboardLamp} alt="" className="w-20 h-20 pt-1" />
            </div>
            <img src={cash_out} alt="" className="aspect-square w-[45px]" />
            <h2
              className={` mx-4 mt-3 ${
                deviceType == "tablet" ? "text-lg" : "text-xl"
              }`}
            >
              {t("Total Refunded Amount")}
            </h2>
          </div>
          <p
            className={`${
              deviceType == "tablet" ? "text-[1.275rem] py-2" : "text-3xl py-6"
            } font-semibold`}
          >
            EGP {dashboardData?.refunded_amt?.toFixed(2) || 0}
          </p>
        </div>

        {/* Total Credit Amount */}
        {showTotalCredit && 
         <div
          className={`flex flex-col  items-start py-4 pr-6 pl-6 bg-[#FFFFFF] rounded-[18px] w-[370px] text-zinc-800 relative ${
            deviceType == "tablet" ? "me-2.5 mt-2.5  " : ""
          }`}
          // onClick={()=>CreditClick()}
        >
          <div className="flex flex-row">
            <div
              className={`absolute -top-1 ${i18n.language == "ar" ? "left-0" : "right-0"} `}
            >
              <img src={DashboardLamp} alt="" className="w-20 h-20 pt-1" />
            </div>
            <img src={cash_out} alt="" className="aspect-square w-[45px]" />
            <h2
              className={` mx-4 mt-3 ${
                deviceType == "tablet" ? "text-lg" : "text-xl"
              }`}
            >
              {t("Total Credit Amount")}
            </h2>
          </div>
          <p
            className={`${
              deviceType == "tablet" ? "text-[1.275rem] py-2" : "text-3xl py-6"
            } font-semibold`}
          >
            EGP {dashboardData?.total_credit?.toFixed(2) || 0}
          </p>
        </div>
        }
       

        {/* Total Delivery Collected */}
        <div
          className={`flex flex-col  items-start py-4 pr-6 pl-6 bg-[#FFFFFF] rounded-[18px] w-[370px] text-zinc-800  relative${
            deviceType == "tablet" ? "me-2.5 mt-2.5 " : ""
          }`}
        >
          <div className="flex flex-row">
            <div
              className={`absolute -top-1 ${i18n.language == "ar" ? "left-0" : "right-0"} `}
            >
              <img src={DashboardLamp} alt="" className="w-20 h-20 pt-1" />
            </div>
            <img src={cash_in} alt="" className="aspect-square w-[45px]" />
            <h2
              className={` mx-4 mt-3 ${
                deviceType == "tablet" ? "text-lg" : "text-xl"
              }`}
            >
              {t("Total Delivery Fee")}
            </h2>
          </div>
          <p
            className={`${
              deviceType == "tablet" ? "text-[1.275rem] py-2" : "text-3xl py-6"
            } font-semibold`}
          >
            EGP {dashboardData?.total_delivery_fee?.toFixed(2) || 0}
          </p>
        </div>

        {dashboardData?.order_from &&
          Object.keys(dashboardData.order_from).length > 0 && (
            <div
              className={`flex flex-col  items-start py-4 pe-6 ps-6 bg-[#FFF0C7] rounded-[18px] min-w-[400px] text-zinc-800 ${
                deviceType == "tablet" ? "me-2.5 mt-2.5 " : ""
              }`}
            >
              <div className="flex flex-row">
                <img
                  src={orders}
                  alt=""
                  className="aspect-square min-w-[45px]"
                />
                <h2
                  className={` mx-4 mt-3 ${
                    deviceType == "tablet" ? "text-lg" : "text-xl"
                  }`}
                >
                  {t("Orders From")}
                </h2>
              </div>
              <div className="mt-4 w-full flex flex-row me-2">
                {Object.entries(dashboardData.order_from).map(
                  ([source, count]) => (
                    <div
                      key={source}
                      className="flex flex-row justify-between py-2 px-6  me-2 rounded-lg bg-white"
                    >
                      <span className="text-xl font-semibold">
                        {source == "self_delivery"
                          ? t("Self Delivery")
                          : t(source)}
                      </span>
                      <span className="text-xl justify-end"> - {count}</span>
                    </div>
                  ),
                )}
              </div>
            </div>
          )}

        {dashboardData?.all_collection &&
          (() => {
            const filteredCollection = Object.fromEntries(
              Object.entries(dashboardData.all_collection).filter(
                ([method]) =>
                  method !== "Credit" && method !== "Cash" && method !== "COD",
              ),
            );

            return (
              Object.keys(filteredCollection).length > 0 && (
                <div className="w-full max-w-full overflow-hidden mt-4">
                  <span className="text-2xl font-semibold mt-7 mb-8 text-slate-900">
                    {t("All Bank Collections")}
                  </span>

                  <CollectionTiles allCollection={filteredCollection} />
                </div>
              )
            );
          })()}
        {/* Version  */}
        <div className="fixed bottom-0 right-2 p-4  text-gray-400 text-sm text-center">
          <img
            src={version_logo}
            alt="version_logo"
            className="h-[80%] w-[80%]"
          />
          {t("v")} {appVersion}
        </div>
        {/* <DetailedCard title="Total Orders" amount={dashboardData?.total_orders} /> */}
        {/* <Dashboard_Table></Dashboard_Table> */}
      </div>
      <div></div>
    </>
  );
}

export default Dashboard;
